import * as React from "react";
const SvgDownArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="#111927" d="m7 10 5 5 5-5z" />
  </svg>
);
export default SvgDownArrow;
